import {URL} from "./constants";

function passwordComb(password) {
  const isNumExist = password.search(/[0-9]/g) >= 0;
  const isEngExist = password.search(/[a-z]/gi) >= 0;
  return isNumExist && isEngExist;
}

export const getFullAssetUrl = url => {
  const regex = /^(http|https):\/\//i;
  const isFullUrl = regex.test(url);

  if (isFullUrl) {
    return url;
  } else {
    return URL.S3_ASSET_STORE + url;
  }
};

export const Validate = {
  passwordComb,
  getFullAssetUrl,
};
